// ============================================================
// Standortmonitor — Library — Actions
// ============================================================

import { DataSlice, SlicePreviewSeries } from './library.model';

export namespace LibraryAction {
  /** Add slice to the library (no-op if signature already exists). */
  export class AddSlice {
    static readonly type = '[Library] Add Slice';
    constructor(public slice: DataSlice) {}
  }

  /** Remove slice by id. */
  export class RemoveSlice {
    static readonly type = '[Library] Remove Slice';
    constructor(public sliceId: string) {}
  }

  /**
   * Toggle slice (plus tool): if the signature already exists,
   * remove it; otherwise add it.
   */
  export class ToggleSlice {
    static readonly type = '[Library] Toggle Slice';
    constructor(public slice: DataSlice) {}
  }

  /** Toggle favorite flag. */
  export class ToggleFavorite {
    static readonly type = '[Library] Toggle Favorite';
    constructor(public sliceId: string) {}
  }

  /** Replace all slices (API hydrate). */
  export class SetSlices {
    static readonly type = '[Library] Set Slices';
    constructor(public slices: DataSlice[]) {}
  }

  /** Add or replace a slice by signature. */
  export class UpsertSlice {
    static readonly type = '[Library] Upsert Slice';
    constructor(public slice: DataSlice) {}
  }

  /** Clear the entire library. */
  export class ClearLibrary {
    static readonly type = '[Library] Clear';
  }

  /** Update preview series for a live slice after refresh. */
  export class UpdateSlicePreview {
    static readonly type = '[Library] Update Slice Preview';
    constructor(
      public sliceId: string,
      public previewSeries: SlicePreviewSeries[],
      public datasetBuiltAt: string,
    ) {}
  }
}
